import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface FiservConfig {
  /** Base URL of the Fiserv Terminal WebAPI e.g. 'https://localhost:44350' */
  apiUrl: string;

  /**
   * Static API key. Use instead of tokenFn when a static key is issued.
   * Sent as X-Api-Key header.
   */
  apiKey?: string;

  /**
   * Function returning the JWT for each request.
   * Can return string, Promise<string>, or Observable<string>.
   * Required when apiKey is not set.
   */
  tokenFn?: () => string | Promise<string> | Observable<string>;

  /**
   * BranchId sent as X-Branch-Id header.
   * Can be a static string or a function.
   */
  branchId?: string | (() => string);
}

export const FISERV_CONFIG = new InjectionToken<FiservConfig>('FISERV_CONFIG');
